import axios from "axios";

const request = axios.create({
    timeout: 0,
})

request.interceptors.request.use(config => {
    if (window.user && window.user.token) {
        config.headers["X-ApiToken"] = window.user.token;
    }
    if (window.CONFIG && window.CONFIG.Account && window.CONFIG.Account.code) {
        config.headers["X-AccountCode"] = window.CONFIG.Account.code;
    }
    config.url = window.ApiUrl.resolve(config.url, config.method, window.webroot);
    return config;
});
request.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error)
);

export default request;
